import React from 'react';
import { FormattedDate, FormattedMessage, injectIntl } from 'react-intl';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { DeleteOutlined } from '@ant-design/icons';
import { Button, Col, Modal, Popconfirm, Row, Table } from 'antd';
import PropTypes from 'prop-types';
import { GetSessionsById, RemoveSessions } from '../actions/AccountAction';
import { INIT_REQUEST_ACCOUNT } from '../constants/actionTypes';
import { locale } from '../constants/global';
import {
	getactionMessages,
	getAuthMessages,
	getErrorMessages,
	getFields,
	getModalMessages,
	getPopConfirm,
	getTableMessages,
} from '../constants/messages';
import 'rc-table/assets/index.css';
import 'rc-table/assets/animation.css';

let authMessages = getAuthMessages(),
	errorMessages = getErrorMessages(),
	fieldMessages = getFields(),
	PopConfirmMessages = getPopConfirm(),
	AccountMessages = getactionMessages(),
	tableMessages = getTableMessages(),
	modalMessages = getModalMessages();

const messages = {
	...authMessages,
	...modalMessages,
	...fieldMessages,
	...errorMessages,
	...AccountMessages,
	...PopConfirmMessages,
	...tableMessages,
};

class SessionForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedUsers: [],
			search: '',
			current: 1,
		};

		const { userId, getSessionsById } = props;

		getSessionsById(userId);
	}
	componentDidUpdate(prevProps) {
		if (prevProps.showModal !== this.props.showModal && this.props.showModal) {
			const { userId, getSessionsById } = this.props;

			getSessionsById(userId);
		}
	}
	onChange = (checkedValues) => {
		this.setState({
			editableRoles: checkedValues,
		});
	};

	delete = () => {
		const { removeSessions, userId } = this.props;

		removeSessions(userId, this.state.selectedUsers);

		this.setState({
			selectedUsers: [],
		});
	};
	pagingOnChange = (page, pageSize) => {
		const { getSessionsById, userId } = this.props;

		getSessionsById(userId, page, pageSize);

		this.setState({
			current: page,
		});
	};

	handleSelectUser = (selected) => {
		this.setState({
			selectedUsers: selected,
		});
	};

	handleSelectUser = (selected) => {
		this.setState({
			selectedUsers: selected,
		});
	};

	showTotal = (total) => {
		return <FormattedMessage {...messages.total} values={{ name: total }} />;
	};

	render() {
		let { intl, showModal, handleCancel, confirmLoading, dataSource, lang, isLoading } = this.props;

		const pagination = {
			defaultPageSize: 5,
			onChange: this.pagingOnChange,
			total: this.props.count,
			showTotal: this.showTotal,
		};
		const rowSelection = {
			onChange: this.handleSelectUser,
			type: 'checkbox',
			selectedRowKeys: this.state.selectedUsers,
			getCheckboxProps: this.props.getCheckboxProps,
		};
		const columns = [
			{
				title: `${intl.formatMessage({ ...messages.ttl })}`,
				dataIndex: 'userId',
				render: (userId, record) => {
					return (
						<span>
							{' '}
							<FormattedMessage {...messages.ttl} />{' '}
							{(this.state.current - 1) * 5 + dataSource.indexOf(record) + 1}
						</span>
					);
				},
			},
			{
				title: `${intl.formatMessage({ ...messages.die })}`,
				dataIndex: 'ttl',
				render: (ttl, record) => {
					let expires = new Date(record.id);
					expires = new Date(expires.getTime() + record.ttl * 1000);
					return (
						<span>
							{
								<Moment locale={locale[lang].intl} fromNow>
									{expires}
								</Moment>
							}
						</span>
					);
				},
			},
			{
				title: `${intl.formatMessage({ ...messages.created })}`,
				dataIndex: 'id',
				render: (id) => {
					return (
						<span>
							{' '}
							<FormattedDate value={new Date(id)} hour12={true} month="short" day="2-digit" />{' '}
						</span>
					);
				},
			},
		];

		return (
			<Modal
				open={showModal}
				title={intl.formatMessage({ ...messages.editSessionsTitle })}
				onOk={this.updateroles}
				confirmLoading={confirmLoading}
				onCancel={handleCancel}
				destroyOnClose={true}
				footer={[
					<Button key="back" size="large" onClick={handleCancel}>
						<FormattedMessage {...messages.close} />
					</Button>,
				]}
			>
				<Row className="sessionControl">
					<Col span={6} className="action">
						<Popconfirm
							title={this.props.intl.formatMessage({ ...messages.deleteSessionConfirm })}
							onConfirm={this.delete}
							okText={this.props.intl.formatMessage({ ...messages.yes })}
							cancelText={this.props.intl.formatMessage({ ...messages.no })}
						>
							<Button className="editable-add-btn">
								<DeleteOutlined />
								<FormattedMessage {...messages.deleteSession} />
							</Button>
						</Popconfirm>
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<Table
							rowKey={(record) => record.id}
							columns={columns}
							dataSource={this.props.dataSource}
							pagination={pagination}
							rowSelection={rowSelection}
							current={this.state.current}
							loading={isLoading}
							size={'small'}
							bordered
						/>
					</Col>
				</Row>
			</Modal>
		);
	}
}

SessionForm.propTypes = {
	intl: PropTypes.object.isRequired,
	showModal: PropTypes.bool.isRequired,
	handleCancel: PropTypes.func.isRequired,
	dataSource: PropTypes.array,
	editableRoles: PropTypes.array,
	userId: PropTypes.number,
	confirmLoading: PropTypes.bool,
	lang: PropTypes.string,
	isLoading: PropTypes.bool,
	count: PropTypes.number,
	getSessionsById: PropTypes.func,
	removeSessions: PropTypes.func,
	getCheckboxProps: PropTypes.func,
};

const mapStateToProps = (state) => {
	return {
		dataSource: state.session.sessions,
		editableRoles: state.role.editableRoles,
		userId: state.account.sessionUserId,
		confirmLoading: state.account.confirmLoading,
		lang: state.int18.language || state.int18.defaultLanguage,
		isLoading: state.account.isLoading,
		count: state.session.count,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getSessionsById: (id, page, pageSize) => {
			dispatch({ type: INIT_REQUEST_ACCOUNT });
			dispatch(GetSessionsById(id, page, pageSize));
		},
		removeSessions: (id, dates) => {
			dispatch({ type: INIT_REQUEST_ACCOUNT });
			dispatch(RemoveSessions(id, dates));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SessionForm));
